import React from 'react'
import * as Sentry from '@sentry/react'

import {
  Box,
  Button,
  Container,
} from '@material-ui/core'

/**
 * Top-level SPA ErrorBoundary.
 * Reports to Sentry when REACT_APP_SENTRY_DSN is baked (see index.js).
 * Context is URL / tenant-host / route only — never dump PII, GraphQL bodies, or tokens.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const href = (typeof window !== 'undefined' && window.location && window.location.href) || '';
    const host = (typeof window !== 'undefined' && window.location && window.location.hostname) || '';
    const path = (typeof window !== 'undefined' && window.location && window.location.pathname) || '';

    // Structured local log (picked up by browser console / smoke harness)
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', {
      message: error && error.message,
      name: error && error.name,
      host,
      path,
      componentStack: errorInfo && errorInfo.componentStack
        ? String(errorInfo.componentStack).slice(0, 2000)
        : undefined,
    });

    try {
      if (typeof Sentry !== 'undefined' && Sentry && typeof Sentry.captureException === 'function') {
        Sentry.captureException(error, {
          tags: {
            surface: 'spa_error_boundary',
            tenant_host: host,
          },
          contexts: {
            kyc_spa: {
              url: href.slice(0, 500),
              path,
              host,
            },
          },
          extra: {
            // Truncated React component stack only (no props / state / PII)
            componentStack: errorInfo && errorInfo.componentStack
              ? String(errorInfo.componentStack).slice(0, 2000)
              : undefined,
          },
        });
      }
    } catch (_e) {
      // never let reporting crash the fallback UI
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container>
          <Box display="flex" justifyContent="center" alignItems="center" className="text-center" style={{minHeight: '100vh'}}>
            <div>
              <h2>Opps! We didn't expected that</h2>
              <p>Please try again and let us know if it happen again.</p>
              <div>
                <Button variant="outlined" color="primary" onClick={() => { window.location.reload() }}>Refresh site</Button>
              </div>
            </div>
          </Box>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary
